import { Component, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'rosie-message-taking-banner',
  templateUrl: './message-taking-banner.component.html',
  styleUrls: ['./message-taking-banner.component.scss'],
  standalone: false,
})
export class MessageTakingBannerComponent {
  @Output() dismissed = new EventEmitter<void>();

  constructor(private router: Router) {}

  dismiss(): void {
    this.dismissed.emit();
  }

  navigate(): void {
    this.router.navigate(['/settings', { section: 'message' }]);
  }
}
